/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Response object for an institute phone
 * @export
 * @interface InstitutePhone
 */
export interface InstitutePhone {
    /**
     * Unique identifier of the institute phone
     * @type {string}
     * @memberof InstitutePhone
     */
    institutePhoneId?: string;
    /**
     * true if the email is a mobile number
     * @type {boolean}
     * @memberof InstitutePhone
     */
    isMobile?: boolean;
    /**
     * number of the institute phone
     * @type {string}
     * @memberof InstitutePhone
     */
    phoneNumber?: string;
    /**
     * prefix of the institute phone
     * @type {string}
     * @memberof InstitutePhone
     */
    phonePrefix?: string;
}

/**
 * Check if a given object implements the InstitutePhone interface.
 */
export function instanceOfInstitutePhone(value: object): value is InstitutePhone {
    return true;
}

export function InstitutePhoneFromJSON(json: any): InstitutePhone {
    return InstitutePhoneFromJSONTyped(json, false);
}

export function InstitutePhoneFromJSONTyped(json: any, ignoreDiscriminator: boolean): InstitutePhone {
    if (json == null) {
        return json;
    }
    return {
        
        'institutePhoneId': json['institutePhoneId'] == null ? undefined : json['institutePhoneId'],
        'isMobile': json['isMobile'] == null ? undefined : json['isMobile'],
        'phoneNumber': json['phoneNumber'] == null ? undefined : json['phoneNumber'],
        'phonePrefix': json['phonePrefix'] == null ? undefined : json['phonePrefix'],
    };
}

export function InstitutePhoneToJSON(json: any): InstitutePhone {
    return InstitutePhoneToJSONTyped(json, false);
}

export function InstitutePhoneToJSONTyped(value?: InstitutePhone | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'institutePhoneId': value['institutePhoneId'],
        'isMobile': value['isMobile'],
        'phoneNumber': value['phoneNumber'],
        'phonePrefix': value['phonePrefix'],
    };
}

